import React, { ReactNode } from "react"
import { css, Theme } from "@emotion/react"
import AddACH from "../../../../public/payments/ach/add_ach.png"

export interface AddNewBankAccountProps {
	addNewBankButton: ReactNode
}

export const AddNewBankAccount: React.FC<AddNewBankAccountProps> = ({ addNewBankButton }) => {
	return (
		<div css={containerStyle}>
			<p>Steps to pay using a ACH Bank Transfer</p>
			<img src={AddACH} css={img} />
			{addNewBankButton}
		</div>
	)
}

const containerStyle = (theme: Theme) => css`
	border-radius: 0.75rem;
	padding: 1.5rem;
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin-left: 2.5rem;
	border-radius: 12px;
	border: 1px solid #d1d5db;
	align-items: center;

	${theme.breakpoints.down("xs")} {
		width: auto;
	}

	p {
		color: #192334ff;
		font-size: 0.875rem;
		font-weight: 500;
		margin-bottom: 1rem;
		text-align: center;
	}
`
const img = css`
	width: 100%;
	max-width: 25rem;
`
